export default __webpack_public_path__ + "advantage-5499ee9.png";